import { Optional } from '@mews/std';

const optionalAtob = (text: Optional<string>) => {
    try {
        return text ? window.atob(text) : null;
    } catch {
        return null;
    }
};

export default optionalAtob;
